import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/content';
import { Reveal } from './Reveal';
export function PainSection() {
  return <section className="bg-paper-soft px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="infierno" data-id="element-152" data-mp="38vu706n62332">
      <div className="mx-auto max-w-6xl" data-id="element-153" data-mp="2v0i5ngei9ed6">
        <Reveal data-id="element-154" data-mp="2yypkg5pes5lq">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-ink-dim" data-id="element-155" data-mp="2yy606icad54j">
            La realidad
          </p>
          <h2 id="infierno" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-156" data-mp="2l6j1ycys9mj4">
            Lo que nadie te dice del fútbol de barrio
          </h2>
          <p className="mt-6 max-w-readable text-lg text-ink-soft" data-id="element-157" data-mp="2g9988l4d2oph">
            Admitámoslo: el fútbol amateur es difícil. Y casi todo lo difícil te toca
            a vos solo.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-x-12 gap-y-10 sm:grid-cols-2" data-id="element-158" data-mp="278bb8mscbhge">
          {pains.map((pain, i) => <Reveal key={pain.title} delay={i * 0.04} data-id="element-159" data-mp="3rmhl2todrg5a" data-mpi={i}>
              <li className="flex gap-4 border-l-2 border-ink/25 pl-5" data-id="element-160" data-mp="3rp3ukyuu05q5">
                <XIcon className="mt-1 h-5 w-5 shrink-0 text-ink/45" aria-hidden="true" data-id="element-161" data-mp="3nknpgzt1l2bz" />
                <div data-id="element-162" data-mp="5dgbeiqbl14f">
                  <h3 className="text-lg font-bold text-ink" data-id="element-163" data-mp="g7v6noqf75t">{pain.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-164" data-mp="38wj4fp6ioeq1">
                    {pain.body}
                  </p>
                </div>
              </li>
            </Reveal>)}
        </ul>

        <Reveal data-id="element-165" data-mp="3imukub7e0gdt">
          <p className="display mt-16 max-w-3xl text-2xl leading-tight text-ink sm:text-4xl" data-id="element-166" data-mp="3ine2rrx1f4ru">
            El problema no sos vos.
            <br data-id="element-167" data-mp="3dub5p9t1xd6w" />
            <span className="text-ink-dim" data-id="element-168" data-mp="3dtt2ft7z1yph">
              Es que estás intentando construir una casa sin planos.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}